import {
	SET_EMPLOYEE_INTEGRATIONS_RESULT,
	SET_DEAL_EVENTS_RESULT,
	SET_TITLE_REQUEST_RESULT,
	SET_UPDATE_EMPLOYEE_INTEGRATION_CREDENTIALS_RESULT,
	SET_CREDIT_APPLICATION_INITIAL_INFO_RESULT,
	SET_STATES_RESULT,
	SET_CREDIT_APPLICATION_EXISTS_RESULT,
	SAVE_CREDIT_APPLICATION_RESULT,
	SUBMIT_CREDIT_APPLICATION_RESULT,
	SET_CREDIT_APPLICATION_INTEGRATIONS_RESULT,
	SET_CREDIT_REPORT_INITIAL_INFO_RESULT,
	SET_CREDIT_REPORT_EXISTS_RESULT,
	SET_CREDIT_REPORT_INTEGRATIONS_RESULT,
	SAVE_CREDIT_REPORT_RESULT,
	SET_RECENT_CREDIT_REPORT_RESULT,
	SUBMIT_CREDIT_REPORT_RESULT,
	SET_CREDIT_REPORT_HISTORY_RESULT,
	SET_ATTACHMENT_RESULT
} from './deal-mutation-types';
import api from '@/services/api-service';
import buildRoute from '@/composables/build-route';

export default {
	strict: process.env.NODE_ENV !== 'production',
	name: 'deal',
	namespaced: true,
	state: {
		employeeIntegrations: undefined,
		dealEvents: undefined,
		updateEmployeeIntegrationCredentialsResult: undefined,
		titleRequestResult: undefined,
		creditApplicationIntialInfo: undefined,
		statesResult: undefined,
		creditApplicationExistsResult: undefined,
		saveCreditApplicationResult: undefined,
		submissionOptionsResult: undefined,
		integrationsResult: undefined,
		submitCreditApplicationResult: undefined,
		creditReportIntialInfo: undefined,
		creditReportExistsResult: undefined,
		bureauIntegrationsResult: undefined,
		saveCreditReportResult: undefined,
		recentCreditReportResult: undefined,
		submitCreditReportResult: undefined,
		creditReportHistoryResult: undefined,
		attachmentResult: undefined
	},
	mutations: {
		[SET_EMPLOYEE_INTEGRATIONS_RESULT](state, employeeIntegrations) {
			state.employeeIntegrations = employeeIntegrations;
		},
		[SET_DEAL_EVENTS_RESULT](state, dealEvents) {
			state.dealEvents = dealEvents;
		},
		[SET_TITLE_REQUEST_RESULT](state, titleRequestResult) {
			state.titleRequestResult = titleRequestResult;
		},
		[SET_UPDATE_EMPLOYEE_INTEGRATION_CREDENTIALS_RESULT](
			state,
			updateEmployeeIntegrationCredentialsResult
		) {
			state.updateEmployeeIntegrationCredentialsResult = updateEmployeeIntegrationCredentialsResult;
		},
		[SET_CREDIT_APPLICATION_INITIAL_INFO_RESULT](state, initialInfo) {
			state.creditApplicationIntialInfo = initialInfo;
		},
		[SET_STATES_RESULT](state, statesResult) {
			state.statesResult = statesResult;
		},
		[SET_CREDIT_APPLICATION_EXISTS_RESULT](
			state,
			creditApplicationExistsResult
		) {
			state.creditApplicationExistsResult = creditApplicationExistsResult;
		},
		[SAVE_CREDIT_APPLICATION_RESULT](state, saveCreditApplicationResult) {
			state.saveCreditApplicationResult = saveCreditApplicationResult;
		},
		[SUBMIT_CREDIT_APPLICATION_RESULT](
			state,
			submitCreditApplicationResult
		) {
			state.submitCreditApplicationResult = submitCreditApplicationResult;
		},
		[SET_CREDIT_APPLICATION_INTEGRATIONS_RESULT](
			state,
			integrationsResult
		) {
			state.integrationsResult = integrationsResult;
		},
		[SET_CREDIT_REPORT_INITIAL_INFO_RESULT](
			state,
			{ initialInfo, isFromCreditApplication = false }
		) {
			state.creditReportIntialInfo = initialInfo;

			if (isFromCreditApplication) {
				state.creditApplicationIntialInfo = {
					...initialInfo,
					applicationHeader: initialInfo.reportHeader
				};
			}
		},
		[SET_CREDIT_REPORT_EXISTS_RESULT](state, creditReportExistsResult) {
			state.creditReportExistsResult = creditReportExistsResult;
		},
		[SET_CREDIT_REPORT_INTEGRATIONS_RESULT](
			state,
			bureauIntegrationsResult
		) {
			state.bureauIntegrationsResult = bureauIntegrationsResult;
		},
		[SAVE_CREDIT_REPORT_RESULT](state, saveCreditReportResult) {
			state.saveCreditReportResult = saveCreditReportResult;
		},
		[SET_RECENT_CREDIT_REPORT_RESULT](state, recentCreditReportResult) {
			state.recentCreditReportResult = recentCreditReportResult;
		},
		[SUBMIT_CREDIT_REPORT_RESULT](state, submitCreditReportResult) {
			state.submitCreditReportResult = submitCreditReportResult;
		},
		[SET_CREDIT_REPORT_HISTORY_RESULT](state, creditReportHistoryResult) {
			state.creditReportHistoryResult = creditReportHistoryResult;
		},
		[SET_ATTACHMENT_RESULT](state, attachmentResult) {
			state.attachmentResult = attachmentResult;
		}
	},
	actions: {
		// actions let us get to ({ state, getters, commit, dispatch }) {
		async sendTitleRequestAction({ commit }, { companyId, titleRequest }) {
			const titleRequestResult = await api.post(
				buildRoute('/sales/company/{companyId}/title-request', {
					companyId
				}),
				titleRequest
			);

			commit(SET_TITLE_REQUEST_RESULT, titleRequestResult);
		},
		async updateEmployeeIntegrationCredentialsAction(
			{ commit },
			{ companyId, integrationId, employeeId, username, password }
		) {
			const result = await api.post(
				buildRoute(
					'/sales/company/{companyId}/employee/{employeeId}/state-integrations/{integrationId}/credentials',
					{
						companyId,
						employeeId,
						integrationId
					}
				),
				{ companyId, integrationId, employeeId, username, password }
			);

			commit(SET_UPDATE_EMPLOYEE_INTEGRATION_CREDENTIALS_RESULT, result);
		},
		async getDealEventsAction({ commit }, { companyId, dealId }) {
			const dealEvents = await api.get(
				buildRoute('/sales/company/{companyId}/deals/{dealId}/events', {
					companyId,
					dealId
				})
			);

			commit(SET_DEAL_EVENTS_RESULT, dealEvents);
		},
		async getEmployeeIntegrationsAction(
			{ commit },
			{ companyId, employeeId, integrationId }
		) {
			const employeeIntegrations = await api.get(
				buildRoute(
					'/sales/company/{companyId}/employee/{employeeId}/state-integrations/{integrationId}',
					{ companyId, employeeId, integrationId }
				)
			);

			commit(SET_EMPLOYEE_INTEGRATIONS_RESULT, employeeIntegrations);
		},
		async getCreditApplicationInitialInfoAction(
			{ commit },
			{ companyId, searchType, searchId }
		) {
			const initialInfo = await api.get(
				buildRoute(
					'/sales/company/{companyId}/creditapplication/initialinfo/{searchType}/{searchId}',
					{ companyId, searchType, searchId }
				)
			);

			commit(SET_CREDIT_APPLICATION_INITIAL_INFO_RESULT, initialInfo);
		},
		async clearCreditApplicationInitialInfoAction({ commit }) {
			commit(SET_CREDIT_APPLICATION_INITIAL_INFO_RESULT, undefined);
		},
		async getStatesAction({ commit }) {
			const statesList = [
				{ text: ' ', value: ' ' },
				{ text: 'Alaska', value: 'AK' },
				{ text: 'Alabama', value: 'AL' },
				{ text: 'Arkansas', value: 'AR' },
				{ text: 'Arizona', value: 'AZ' },
				{ text: 'California', value: 'CA' },
				{ text: 'Colorado', value: 'CO' },
				{ text: 'Connecticut', value: 'CT' },
				{ text: 'District Of Columbia', value: 'DC' },
				{ text: 'Delaware', value: 'DE' },
				{ text: 'Florida', value: 'FL' },
				{ text: 'Georgia', value: 'GA' },
				{ text: 'Hawaii', value: 'HI' },
				{ text: 'Iowa', value: 'IA' },
				{ text: 'Idaho', value: 'ID' },
				{ text: 'Illinois', value: 'IL' },
				{ text: 'Indiana', value: 'IN' },
				{ text: 'Kansas', value: 'KS' },
				{ text: 'Kentucky', value: 'KY' },
				{ text: 'Louisiana', value: 'LA' },
				{ text: 'Massachusetts', value: 'MA' },
				{ text: 'Maryland', value: 'MD' },
				{ text: 'Maine', value: 'ME' },
				{ text: 'Michigan', value: 'MI' },
				{ text: 'Minnesota', value: 'MN' },
				{ text: 'Missouri', value: 'MO' },
				{ text: 'Mississippi', value: 'MS' },
				{ text: 'Montana', value: 'MT' },
				{ text: 'North Carolina', value: 'NC' },
				{ text: 'North Dakota', value: 'ND' },
				{ text: 'Nebraska', value: 'NE' },
				{ text: 'New Hampshire', value: 'NH' },
				{ text: 'New Jersey', value: 'NJ' },
				{ text: 'New Mexico', value: 'NM' },
				{ text: 'Nevada', value: 'NV' },
				{ text: 'New York', value: 'NY' },
				{ text: 'Ohio', value: 'OH' },
				{ text: 'Oklahoma', value: 'OK' },
				{ text: 'Oregon', value: 'OR' },
				{ text: 'Pennsylvania', value: 'PA' },
				{ text: 'Rhode Island', value: 'RI' },
				{ text: 'South Carolina', value: 'SC' },
				{ text: 'South Dakota', value: 'SD' },
				{ text: 'Tennessee', value: 'TN' },
				{ text: 'Texas', value: 'TX' },
				{ text: 'Utah', value: 'UT' },
				{ text: 'Virginia', value: 'VA' },
				{ text: 'Vermont', value: 'VT' },
				{ text: 'Washington', value: 'WA' },
				{ text: 'Wisconsin', value: 'WI' },
				{ text: 'West Virginia', value: 'WV' },
				{ text: 'Wyoming', value: 'WY' }
			];

			await commit(SET_STATES_RESULT, statesList);
		},
		async getCreditApplicationExistsAction(
			{ commit },
			{ companyId, searchType, searchId }
		) {
			const creditApplicationExistsResult = await api.get(
				buildRoute(
					'/sales/company/{companyId}/creditapplication/check/{searchType}/{searchId}',
					{ companyId, searchType, searchId }
				)
			);

			commit(
				SET_CREDIT_APPLICATION_EXISTS_RESULT,
				creditApplicationExistsResult
			);
		},
		async getCreditReportExistsAction(
			{ commit },
			{ companyId, searchType, searchId }
		) {
			const creditReportExistsResult = await api.get(
				buildRoute(
					'/sales/company/{companyId}/creditReport/check/{searchType}/{searchId}',
					{ companyId, searchType, searchId }
				)
			);

			commit(SET_CREDIT_REPORT_EXISTS_RESULT, creditReportExistsResult);
		},
		async clearCreditReportExistsAction({ commit }) {
			commit(SET_CREDIT_REPORT_EXISTS_RESULT, undefined);
		},
		async clearCreditApplicationExistsAction({ commit }) {
			commit(SET_CREDIT_APPLICATION_EXISTS_RESULT, undefined);
		},
		async getCreditApplicationScenarioAction(
			{ commit },
			{ companyId, scenarioId }
		) {
			const initialInfo = await api.get(
				buildRoute(
					'/sales/company/{companyId}/creditapplication/get/scenario/{scenarioId}',
					{ companyId, scenarioId }
				)
			);

			commit(SET_CREDIT_APPLICATION_INITIAL_INFO_RESULT, initialInfo);
		},
		async clearCreditApplicationScenarioAction({ commit }) {
			commit(SET_CREDIT_APPLICATION_INITIAL_INFO_RESULT, undefined);
		},
		async getCreditApplicationProspectAction(
			{ commit },
			{ companyId, prospectId }
		) {
			const initialInfo = await api.get(
				buildRoute(
					'/sales/company/{companyId}/creditapplication/get/prospect/{prospectId}',
					{ companyId, prospectId }
				)
			);

			commit(SET_CREDIT_APPLICATION_INITIAL_INFO_RESULT, initialInfo);
		},
		async clearCreditApplicationProspectAction({ commit }) {
			commit(SET_CREDIT_APPLICATION_INITIAL_INFO_RESULT, undefined);
		},
		async saveCreditApplicationAction(
			{ commit },
			{ companyId, CreditApp }
		) {
			let errorResult = null;
			const saveCreditApplicationResult = await api.post(
				buildRoute(
					'/sales/company/{companyId}/creditapplication/save',
					{ companyId: companyId }
				),
				CreditApp,
				function(error) {
					errorResult = {
						status: 'failure',
						response: JSON.parse(JSON.stringify(error.response))
					};
				}
			);

			if (errorResult != null)
				commit(SAVE_CREDIT_APPLICATION_RESULT, errorResult);
			else
				commit(
					SAVE_CREDIT_APPLICATION_RESULT,
					saveCreditApplicationResult
				);
		},
		async getAttachmentAction(
			{ commit },
			{ companyId, attachmentGUID, extension }
		) {
			const attachmentResult = await api.get(
				buildRoute(
					'sales/company/{companyId}/creditapplication/getattachment/{attachmentGUID}/{extension}',
					{ companyId, attachmentGUID, extension }
				)	
			);
			
			commit(SET_ATTACHMENT_RESULT, attachmentResult);
		},
		async getCreditReportScenarioAction(
			{ commit },
			{ companyId, scenarioId, isFromCreditApplication }
		) {
			const initialInfo = await api.get(
				buildRoute(
					'/sales/company/{companyId}/creditReport/get/scenario/{scenarioId}',
					{ companyId, scenarioId }
				)
			);

			commit(SET_CREDIT_REPORT_INITIAL_INFO_RESULT, {
				initialInfo,
				isFromCreditApplication
			});
		},
		async getCreditReportProspectAction(
			{ commit },
			{ companyId, prospectId, isFromCreditApplication }
		) {
			const initialInfo = await api.get(
				buildRoute(
					'/sales/company/{companyId}/creditReport/get/prospect/{prospectId}',
					{ companyId, prospectId }
				)
			);

			commit(SET_CREDIT_REPORT_INITIAL_INFO_RESULT, {
				initialInfo,
				isFromCreditApplication
			});
		},
		async clearCreditReportScenarioAction({ commit }) {
			commit(SET_CREDIT_REPORT_INITIAL_INFO_RESULT, undefined);
		},
		async clearCreditReportProspectAction({ commit }) {
			commit(SET_CREDIT_REPORT_INITIAL_INFO_RESULT, undefined);
		},
		async submitCreditApplicationAction(
			{ commit },
			{ companyId, CreditApp }
		) {
			const submitCreditApplicationResult = await api.post(
				buildRoute(
					'/sales/company/{companyId}/creditapplication/submit',
					{ companyId: companyId }
				),
				CreditApp
			);

			commit(
				SUBMIT_CREDIT_APPLICATION_RESULT,
				submitCreditApplicationResult
			);
		},
		async getIntegrationsAction({ commit }, { companyId, vendorName }) {
			const integrationsResult = await api.get(
				buildRoute(
					'/sales/company/{companyId}/creditapplication/getintegrations/{vendorName}',
					{ companyId, vendorName }
				)
			);

			commit(
				SET_CREDIT_APPLICATION_INTEGRATIONS_RESULT,
				integrationsResult
			);
		},
		async getCreditReportInitialInfoAction(
			{ commit },
			{ companyId, searchType, searchId }
		) {
			const initialInfo = await api.get(
				buildRoute(
					'/sales/company/{companyId}/creditreport/initialinfo/{searchType}/{searchId}',
					{ companyId, searchType, searchId }
				)
			);

			commit(SET_CREDIT_REPORT_INITIAL_INFO_RESULT, {
				initialInfo 
			});
		},
		async getCreditReportIntegrationsAction(
			{ commit },
			{ companyId, vendorName }
		) {
			const bureauIntegrationsResult = await api.get(
				buildRoute(
					'/sales/company/{companyId}/creditreport/getintegrations/{vendorName}',
					{ companyId, vendorName }
				)
			);

			commit(
				SET_CREDIT_REPORT_INTEGRATIONS_RESULT,
				bureauIntegrationsResult
			);
		},
		async clearCreditReportInitialInfoAction({ commit }) {
			commit(SET_CREDIT_REPORT_INITIAL_INFO_RESULT, undefined);
		},
		async saveCreditReportAction({ commit }, { companyId, CreditReport }) {
			let errorResult = null;
			const saveCreditReportResult = await api.post(
				buildRoute('/sales/company/{companyId}/creditreport/save', {
					companyId: companyId
				}),
				CreditReport,
				function(error) {
					errorResult = {
						status: 'failure',
						response: JSON.parse(JSON.stringify(error.response))
					};
				}
			);

			if (errorResult != null)
				commit(SAVE_CREDIT_REPORT_RESULT, errorResult);
			else commit(SAVE_CREDIT_REPORT_RESULT, saveCreditReportResult);
		},
		async getRecentCreditReportAction(
			{ commit },
			{ companyId, searchType, searchId }
		) {
			const recentCreditReportResult = await api.get(
				buildRoute(
					'/sales/company/{companyId}/creditreport/getrecentcreditreport/{searchType}/{searchId}',
					{ companyId, searchType, searchId }
				)
			);

			commit(SET_RECENT_CREDIT_REPORT_RESULT, recentCreditReportResult);
		},
		async submitCreditReportAction(
			{ commit },
			{ companyId, CreditReport }
		) {
			const submitCreditReportResult = await api.post(
				buildRoute('/sales/company/{companyId}/creditreport/submit', {
					companyId: companyId
				}),
				CreditReport
			);

			commit(
				SUBMIT_CREDIT_REPORT_RESULT, 
				submitCreditReportResult
			);
		},
		async getCreditReportHistoryAction(
			{ commit },
			{ companyId, attachmentGUID, extension }
		) {
			const creditReportHistoryResult = await api.get(
				buildRoute(
					'/sales/company/{companyId}/creditreport/getcreditreporthistory/{attachmentGUID}/{extension}',
					{ companyId, attachmentGUID, extension }
				)	
			);
			
			commit(SET_CREDIT_REPORT_HISTORY_RESULT, creditReportHistoryResult);
		}
	},
	getters: {
		employeeIntegrations: state => state.employeeIntegrations,
		dealEvents: state => state.dealEvents,
		updateEmployeeIntegrationCredentialsResult: state =>
			state.updateEmployeeIntegrationCredentialsResult,
		titleRequestResult: state => state.titleRequestResult,
		creditApplicationIntialInfo: state => state.creditApplicationIntialInfo,
		statesResult: state => state.statesResult,
		creditApplicationExistsResult: state =>
			state.creditApplicationExistsResult,
		saveCreditApplicationResult: state => state.saveCreditApplicationResult,
		submitCreditApplicationResult: state =>
			state.submitCreditApplicationResult,
		integrationsResult: state => state.integrationsResult,
		creditReportIntialInfo: state => state.creditReportIntialInfo,
		creditReportExistsResult: state => state.creditReportExistsResult,
		bureauIntegrationsResult: state => state.bureauIntegrationsResult,
		saveCreditReportResult: state => state.saveCreditReportResult,
		recentCreditReportResult: state => state.recentCreditReportResult,
		submitCreditReportResult: state => state.submitCreditReportResult,
		creditReportHistoryResult: state => state.creditReportHistoryResult,
		attachmentResult: state => state.attachmentResult
	}
};
